import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const userRole = localStorage.getItem('roleID');

    // Get the required role for this route from route data
    // const requiredRoleId = next.data['roleId'];
    const allowedRoles: string[] = next.data['roleId'];

    // if (userRole && userRole === requiredRoleId) {
    if (userRole && allowedRoles?.includes(userRole)) {
      return true;
    } else {
      // If the role doesn't match, redirect to an error page or login
      this.router.navigate(['/home/calendar']);
      return false;
    }
  }
}
